import './BlogHubPage.css'
import { Link, useLocation } from 'react-router-dom';

const BlogHubPage = ({ hubObj }) => {
  const  location  = useLocation();
  const { metaTitle, metaDescription, articles } = hubObj;
  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";
  const langPrefix = currentLang === "ru" ? "/ru" : "";
  return (
    <div className='page'>
             <title>{metaTitle}</title>
             <meta name="description" content={metaDescription}/>
      <div className="articles__wrapper">
      {
        articles.map((article, idx) => {
          return (
            <Link to={`${langPrefix}/blog/${article.link}`} key={idx} className="article-card">
                <img src={article.image} alt={article.title} className="article-image" />
                <div className="article-texts">
                <h3 className="article-title mont-m">{article.title}</h3>
                <p className="article-description int-r-21">{article.description}</p>
                </div>
            </Link>
          )
        })
      }
      </div>
    </div>
  )
}

export default BlogHubPage